/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { IAjaxProvider } from 'jinqu';
import { LinqService, QueryOptions } from 'linquest';
import {
  DepartmentResultDto,
  ComparisonAnalysisEmployeeDto,
  ComparisonGroupCalculatedDto,
  YearParameter,
  ComparisonAnalysisGroupDto,
} from './models';

/**
 * ComparisonGroupCalculatedApi - API class
 */
export class ComparisonGroupCalculatedApi extends LinqService {

  /**
   * Creates a new ComparisonGroupCalculatedApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * @param dto 
   */
  addOrUpdateAsync(dto?: ComparisonGroupCalculatedDto, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/AddOrUpdateAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  deleteAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/DeleteAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param id 
   */
  getAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetAsync`;
    let query = this.createQuery<ComparisonGroupCalculatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param yearParams 
   */
  getComparisonAnalysisOfCurrentUser(yearParams?: YearParameter, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetComparisonAnalysisOfCurrentUser`;
    let query = this.createQuery<ComparisonAnalysisEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = yearParams;
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param yearParams 
   */
  getComparisonAnalysisOfTeamAsEmployee(yearParams?: YearParameter, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetComparisonAnalysisOfTeamAsEmployee`;
    let query = this.createQuery<ComparisonAnalysisEmployeeDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = yearParams;
    query = query.withOptions(options);

    return query;
  }

  /**
   * @param yearParams 
   */
  getComparisonAnalysisOfTeamAsGroup(yearParams?: YearParameter, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetComparisonAnalysisOfTeamAsGroup`;
    let query = this.createQuery<ComparisonAnalysisGroupDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = yearParams;
    query = query.withOptions(options);

    return query;
  }

  /**
   */
  getDepartmentWithSubDepartmentsOfCurrentUser(options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetDepartmentWithSubDepartmentsOfCurrentUser`;
    let query = this.createQuery<DepartmentResultDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * @param id 
   */
  getTranslatedAsync(id?: string, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/GetTranslatedAsync`;
    let query = this.createQuery<ComparisonGroupCalculatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   */
  list(options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/List`;
    let query = this.createQuery<ComparisonGroupCalculatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  listTranslated(options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/ListTranslated`;
    let query = this.createQuery<ComparisonGroupCalculatedDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   */
  recalculateAllComparisonResultsForThisYear(options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/RecalculateAllComparisonResultsForThisYear`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param dto 
   */
  saveAsync(dto?: ComparisonGroupCalculatedDto, options?: QueryOptions) {
    // create query
    const url = `/ComparisonGroupCalculated/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
